import CheckEmail from 'stash/components/check-email/CheckEmail';
import ForgotPassword from 'stash/components/forgot-password/ForgotPassword';
import ResetPassword from 'stash/components/reset-password/ResetPassword';
import ResetPasswordSuccess from 'stash/components/reset-password/ResetPasswordSuccess';
import LoginRoute from './LogInRoute';
import AuthorizeRoute from './AuthorizeRoute';
import LogInThirdParty from 'stash/components/log-in/LogInThirdParty';

export default {
	CheckEmail,
	ForgotPassword,
	ResetPassword,
	ResetPasswordSuccess,
	LoginRoute,
	AuthorizeRoute,
	LogInThirdParty,
};
